import { Immutable } from "immer";
import React from "react";
import { ProductGridSSR } from "tsi-common-react/src/apps/product-grid2/ProductGridSSR/index";
import { PromoConditionalBlock } from "tsi-common-react/src/components/PromoConditionalBlock/index";

import { templates } from "@reactivated";
import type {
    PillowsPromoConditionalBlock,
    PillowsToolboxPromoConditionalBlock,
} from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { DiscoverTempurLoveBlock } from "../../blocks/DiscoverTempurLoveBlock";
import { InsideInnovationBlock } from "../../blocks/InsideInnovationBlock";
import { OfferSectionBlock } from "../../blocks/OfferSectionBlock";
import {
    pillowsPromoConditionalInnerMap,
    toolboxComponentsMap,
} from "../../blocks/toolboxComponentsMap";

/**
 * Component map for the pillows ProductFilterGridPage body. Exported so the
 * block-screenshot styleguide harness renders through the same map production
 * uses (see ``StyleguideBlockTemplate.tsx``).
 */
export const productFilterGridPageBodyComponentsMap = {
    ...toolboxComponentsMap,
    // PillowsToolboxPromoConditionalBlock: content is a ToolboxContent
    // StreamBlock, dispatched through the same toolboxComponentsMap.
    promo_conditional_block: (block: {
        value: Immutable<PillowsToolboxPromoConditionalBlock>;
    }) => (
        <PromoConditionalBlock value={block.value}>
            <StreamField
                tagName={React.Fragment}
                value={block.value.content ?? []}
                components={toolboxComponentsMap}
            />
        </PromoConditionalBlock>
    ),
    // PillowsPromoConditionalBlock: content is popular_products + banner.
    promo_conditional: (block: {
        value: Immutable<PillowsPromoConditionalBlock>;
    }) => (
        <PromoConditionalBlock value={block.value}>
            <StreamField
                tagName={React.Fragment}
                value={block.value.content ?? []}
                components={pillowsPromoConditionalInnerMap}
            />
        </PromoConditionalBlock>
    ),
    offer_section: OfferSectionBlock,
    innovation_inside: InsideInnovationBlock,
    discover_tempur_love: DiscoverTempurLoveBlock,
    product_grid: (block: {
        value: React.ComponentProps<typeof ProductGridSSR> | null;
    }) => (block.value ? <ProductGridSSR {...block.value} /> : null),
} as const;

export const ProductFilterGridPageBody = (
    props: Immutable<{ page: templates.ProductFilterGridPageTemplate["page"] }>,
): React.JSX.Element | null => {
    if (!props.page.body) {
        return null;
    }
    return (
        <StreamField
            tagName={React.Fragment}
            value={props.page.body.value}
            components={productFilterGridPageBodyComponentsMap}
        />
    );
};
